import { render, staticRenderFns } from "./SliderSettingsController.vue?vue&type=template&id=51ef8f12&scoped=true"
import script from "./SliderSettingsController.vue?vue&type=script&lang=js"
export * from "./SliderSettingsController.vue?vue&type=script&lang=js"
import style0 from "./SliderSettingsController.vue?vue&type=style&index=0&id=51ef8f12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef8f12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ef8f12')) {
      api.createRecord('51ef8f12', component.options)
    } else {
      api.reload('51ef8f12', component.options)
    }
    module.hot.accept("./SliderSettingsController.vue?vue&type=template&id=51ef8f12&scoped=true", function () {
      api.rerender('51ef8f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/SliderSettingsController.vue"
export default component.exports